(function(){
'use strict';

angular.module('classy.frs').component('registrationTicketType', {
  template: '\n      <article class="ticket-type {{$ctrl.ticketId}}"\n        ng-class="{\n          \'ticket-type_fundraising-minimum\': $ctrl.showCommitment,\n          \'is-disabled\': $ctrl.isDisabled || $ctrl.soldOut,\n          \'show-details\': $ctrl.showDetails\n        }" aria-label="{{:: $ctrl.name }}">\n\n        <!-- Edge decoration -->\n        <div class="ticket-type__cutout"></div>\n\n        <!-- Ticket body -->\n        <div class="ticket-type__main">\n\n          <div class="ticket-type__inner">\n            <h2 class="ticket-type__name">{{:: $ctrl.name }}</h2>\n            <span class="ticket-type__price-amount--mobile">\n              {{ $ctrl.displayPrice(true) }}\n            </span>\n            \n            <fundraising-minimum-disclaimer ng-if="$ctrl.showCommitment"\n              minimum-value="$ctrl.commitment.value"\n              minimum-deadline="$ctrl.commitmentDeadline"\n            ></fundraising-minimum-disclaimer>\n            \n            <div class="ticket-type__attendee-count" ng-if="$ctrl.attendeesPer > 1">\n              <i class="ticket-type__attendees-icon ci ci-ico_attendees"></i>Includes {{:: $ctrl.attendeesPer}} attendees\n            </div>\n\n            <div class="ticket-type__description">\n              <p class="ticket-type__description-inner">{{:: $ctrl.description }}</p>\n            </div>\n\n            <a href="" class="ticket-type__description-toggle" aria-hidden="{{ $ctrl.showDetails }}"\n              ng-if="!$ctrl.showDetails && $ctrl.shouldToggle"\n              ng-click="$ctrl.toggleDetails($event)"\n              aria-label="Click to reveal full description of ticket type.">Show more</a>\n\n          </div>\n\n          <a href="" ng-click="$ctrl.toggleDetails($event)" class="ticket-type__description-toggle--hide"\n          ng-if="$ctrl.showDetails"\n          aria-label="Click to hide full description of ticket type.">Show less</a>\n        </div>\n\n        <!-- Ticket stub -->\n        <div class="ticket-type__actions">\n          <div class="ticket-type__price">\n            <span class="ticket-type__price-amount">\n              {{ $ctrl.displayPrice(false) }}\n            </span>\n          </div>\n          \n          <div class="ticket-type__quantity" ng-if="!$ctrl.soldOut">\n\n            <!-- Subtract item -->\n            <button class="ticket-type__button"\n              aria-label="decrease {{:: $ctrl.name }} count"\n              data-ng-click="$ctrl.remove()"\n              data-ng-class="{ \'is-disabled\': $ctrl.isDisabled || $ctrl.currentQuantity === 0 }"\n              data-ng-disabled="$ctrl.isDisabled || $ctrl.currentQuantity === 0">\n              <i class="fa fa-minus ticket-type__quantity-subtract"></i>\n            </button>\n\n            <!-- Current quantity -->\n            <span class="ticket-type__quantity-total" aria-live="assertive" ng-bind="$ctrl.currentQuantity"></span>\n\n            <!-- Add item -->\n            <button class="ticket-type__button"\n              aria-label="increase {{:: $ctrl.name }} count"\n              data-ng-click="$ctrl.add()"\n              data-ng-class="{ \'is-disabled\': $ctrl.isDisabled || $ctrl.currentQuantity === $ctrl.maxQuantity }"\n              data-ng-disabled="$ctrl.isDisabled || $ctrl.currentQuantity === $ctrl.maxQuantity">\n              <i class="fa fa-plus ticket-type__quantity-add"></i>\n            </button>\n\n          </div>\n\n          <button ng-if="$ctrl.currentQuantity" ng-click="$ctrl.focusOrderCart()" class="sr-only" aria-hidden="true" tabindex="{{$ctrl.currentQuantity ? -1 : 0}}">Skip to Review Registration Cart</button>\n          \n          <div class="ticket-type__quantity ticket-type__quantity--sold-out" ng-if="$ctrl.soldOut">\n            SOLD OUT\n          </div>\n          \n        </div>\n\n      </article>\n    ',
  bindings: {
    name: '<',
    ticketId: '<',
    description: '<',
    price: '<',
    isDisabled: '<',
    attendeesPer: '<',
    currentQuantity: '<',
    maxQuantity: '<',
    soldOut: '<',
    commitment: '<',
    add: '&onAdd',
    remove: '&onRemove'
  },
  controller: ["$timeout", "$anchorScroll", "scThemesService", "scCampaignsService", function controller($timeout, $anchorScroll, scThemesService, scCampaignsService) {
    var _this = this;

    var ticketSelector = void 0;

    var innerMaxHeight = 200;

    this.showDetails = false;
    this.shouldToggle = false;

    // check if we should add "show details" link to ticket
    // if description is available & makes inner div reach its max height
    this.getShouldToggle = function (currentTicket) {
      if ($(currentTicket + ' .ticket-type__inner').height() >= innerMaxHeight) {
        return true;
      }
      return false;
    };

    this.displayPrice = function (isForMobile) {
      if (_this.price === '$0.00') {
        return 'Free';
      }
      return _this.price + (isForMobile ? '/ea.' : '');
    };

    this.toggleDetails = function (event) {
      _this.showDetails = !_this.showDetails;

      if (_this.showDetails) {
        $(event.target).closest('.ticket-type__main').focus();
      } else if (!_this.showDetails) {
        $(event.target).parent().find('.ticket-type__main').focus();
      }
    };

    this.$onInit = function () {
      // Use AngularJS’s $anchorScroll() service to programmatically scroll to the top of the page to stop unwanted scrolling to the
      // bottom of the registration-ticket-type list on iOS browsers (Safari & Chrome).
      $anchorScroll();
      _this.showCommitment = _.get(scCampaignsService, 'active.current.type') === 'reg_w_fund' && !!_this.commitment;

      if (_this.showCommitment) _this.commitmentDeadline = new Date(_this.commitment.deadline.replace(' ', 'T'));

      _this.ticketTerm = scThemesService.active.getTicketTerm();

      $timeout(function () {
        ticketSelector = '.ticket-type.' + _this.ticketId;
        _this.shouldToggle = _this.getShouldToggle(ticketSelector);
      }, 100);
    };

    this.focusOrderCart = function () {
      angular.element('.registration-cart')[0].focus();
    };
  }]
});
})();